
var UrlConfig = {

/* 需要传fromid的接口
 * fromid:　产品形态
 */

  fromidUrl: {
    '/v1/Gqyapi/index': '感情运2019首页',
    '/v1/bzjp2018/index': '八字精批2018首页',
    '/v1/Yishengcaiyun/index': '一生财运首页',
    '/v1/Lnyc/index': '猪年运势首页',
    '/v1/Snxj/index': '十年吉凶首页',
    '/v1/Lsy/index': '来生运首页',
    '/v1/Relationproduct/index': '底部热门测算'
  },

/*
 * 获取URL查询参数
 * @param {string} key 参数名
 * @returns 参数值
 */

  getUrlQuery: function (key) {
    var data = {}
    var urlData = location.href.split('?')

    if (urlData.length >= 2) {

      var Querys = urlData[1].split('&')

      Querys.forEach(item => {
        var query = item.split('=')
        data[query[0]] = query[1]
      });

      if (key) {
        return data[key]
      }

      return data
    }

  }
}

export { UrlConfig }


// WEBPACK FOOTER //
// ./src/api/config.js